export enum TEMPLATE_EDITOR_TYPES {
  TEMPLATE = 'template',
  WORKFLOW = 'workflow',
  LAYOUT = 'layout',
}
